import { NavItem } from './nav-item/nav-item';

export const adminItems: NavItem[] = [
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    route: '/dashboard',
    permission: 'dashboard',
  },

  {
    displayName: 'Trips',
    iconName: 'route',
    route: 'apps/trips',
    permission: 'trips',
    children: [
      {
        displayName: 'Create',
        iconName: 'point',
        route: 'apps/trips/add',
        permission: 'trips',
        action: 'create',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/trips/list',
        permission: 'trips',
      }
    ],
  },

  {
    displayName: 'Fuel Orders',
    iconName: 'gas-station',
    route: 'apps/fuel-orders',
    permission: 'fuel_orders',
    children: [
      {
        displayName: 'Create',
        iconName: 'point',
        route: 'apps/fuel-orders/add',
        permission: 'fuel_orders',
        action: 'create',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/fuel-orders/list',
        permission: 'fuel_orders',
      }
    ],
  },

  {
    displayName: 'Stations',
    iconName: 'building-warehouse',
    route: 'apps/stations',
    permission: 'stations',
    children: [
      {
        displayName: 'Add',
        iconName: 'point',
        route: 'apps/stations/add',
        permission: 'stations',
        action: 'create',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/stations/list',
        permission: 'stations',
      }
    ],
  },

  {
    displayName: 'Parking',
    iconName: 'parking',
    route: 'apps/parking',
    children: [
      {
        displayName: 'Config',
        iconName: 'point',
        route: 'apps/parking/config',
        permission: 'parking_config',
      },
      {
        displayName: 'Yards',
        iconName: 'point',
        route: 'apps/parking/yards',
        permission: 'parking_yards',
      },
      {
        displayName: 'Owners',
        iconName: 'point',
        route: 'apps/parking/owners',
        permission: 'parking_owners',
      },
      {
        displayName: 'Sessions',
        iconName: 'point',
        route: 'apps/parking/sessions',
        permission: 'parking_sessions',
      },
      {
        displayName: 'Bills',
        iconName: 'point',
        route: 'apps/parking/bills',
        permission: 'parking_bills',
      }
    ],
  },

  {
    displayName: 'Vehicles',
    iconName: 'truck',
    route: 'apps/vehicles',
    permission: 'vehicles',
    children: [
      {
        displayName: 'Add',
        iconName: 'point',
        route: 'apps/vehicles/add',
        permission: 'vehicles',
        action: 'create',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/vehicles/list',
        permission: 'vehicles',
      }
    ],
  },

  {
    displayName: 'Trailers',
    iconName: 'truck-loading',
    route: 'apps/trailers',
    permission: 'trailers',
    children: [
      {
        displayName: 'Add',
        iconName: 'point',
        route: 'apps/trailers/add',
        permission: 'trailers',
        action: 'create',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/trailers/list',
        permission: 'trailers',
      }
    ],
  },

  {
    displayName: 'Drivers',
    iconName: 'user',
    route: 'apps/drivers',
    permission: 'drivers',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/drivers/list',
        permission: 'drivers',
      }
    ],
  },

  {
    displayName: 'Inventory',
    iconName: 'packages',
    route: 'apps/inventory',
    permission: 'inventory',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/inventory/list',
        permission: 'inventory',
      },
      {
        displayName: 'Tyres',
        iconName: 'point',
        route: 'apps/inventory/tyres',
        permission: 'inventory_tyres',
      }
    ],
  },

  {
    displayName: 'Payroll',
    iconName: 'cash',
    route: 'apps/payroll',
    permission: 'payroll',
    children: [
      {
        displayName: 'Create',
        iconName: 'point',
        route: 'apps/payroll/add',
        permission: 'payroll',
        action: 'create',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/payroll/list',
        permission: 'payroll',
      },
      {
        displayName: 'Statutory rates',
        iconName: 'point',
        route: 'apps/payroll/statutory',
        permission: 'payroll_statutory',
      },
      {
        displayName: 'Deduction types',
        iconName: 'point',
        route: 'apps/payroll/deduction-types',
        permission: 'payroll_deduction_types',
      },
      {
        displayName: 'Staff loans',
        iconName: 'point',
        route: 'apps/loans/list',
        permission: 'loans',
      },
      {
        displayName: 'Issue loan',
        iconName: 'point',
        route: 'apps/loans/add',
        permission: 'loans',
        action: 'create',
      },
      {
        displayName: 'Penalties',
        iconName: 'point',
        route: 'apps/payroll/penalties',
        permission: 'payroll_penalties',
      },
      {
        displayName: 'Add penalty',
        iconName: 'point',
        route: 'apps/payroll/penalties/add',
        permission: 'payroll_penalties',
        action: 'create',
      },
      {
        displayName: 'Reports',
        iconName: 'point',
        route: 'apps/payroll/reports',
        permission: 'payroll_reports',
      },
      {
        displayName: 'Department payroll',
        iconName: 'point',
        route: 'apps/payroll/reports/department-analysis',
        permission: 'payroll_department',
      },
      {
        displayName: 'SHIF deductions',
        iconName: 'point',
        route: 'apps/payroll/reports/shif',
        permission: 'payroll_shif',
      },
      {
        displayName: 'PAYE',
        iconName: 'point',
        route: 'apps/payroll/reports/paye',
        permission: 'payroll_paye',
      },
      {
        displayName: 'NSSF',
        iconName: 'point',
        route: 'apps/payroll/reports/nssf',
        permission: 'payroll_nssf',
      },
      {
        displayName: 'Affordable housing',
        iconName: 'point',
        route: 'apps/payroll/reports/housing-levy',
        permission: 'payroll_housing',
      },
      {
        displayName: 'Penalty deductions',
        iconName: 'point',
        route: 'apps/payroll/reports/penalties',
        permission: 'payroll_penalties',
      },
      {
        displayName: 'Bank transfer',
        iconName: 'point',
        route: 'apps/payroll/reports/bank-transfer',
        permission: 'payroll_bank_transfer',
      },
    ],
  },

  {
    displayName: 'Advances',
    iconName: 'wallet',
    route: 'apps/advances',
    permission: 'advances',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/advances/list',
        permission: 'advances',
      },
      {
        displayName: 'Issue advance',
        iconName: 'point',
        route: 'apps/advances/add',
        permission: 'advances',
        action: 'create',
      },
    ],
  },

  {
    displayName: 'Finance',
    iconName: 'receipt',
    route: 'apps/finance',
    permission: 'finance',
    children: [
      {
        displayName: 'Expenses',
        iconName: 'point',
        route: 'apps/finance/expenses/list',
        permission: 'finance',
      },
      {
        displayName: 'Expense categories',
        iconName: 'point',
        route: 'apps/finance/expenses/categories',
        permission: 'finance_expense_categories',
      },
      {
        displayName: 'Petty Cash Funds',
        iconName: 'point',
        route: 'apps/finance/petty-cash/list',
        permission: 'finance_petty_cash',
      }
    ],
  },

  {
    displayName: 'Payments',
    iconName: 'moneybag',
    route: 'apps/payments',
    permission: 'payments',
    children: [
      {
        displayName: 'Payment List',
        iconName: 'point',
        route: 'apps/payments/payments',
        permission: 'payments',
      },
      {
        displayName: 'Payment Methods',
        iconName: 'point',
        route: 'apps/payments/methods',
        permission: 'payments_methods',
      }
    ],
  },

  {
    displayName: 'Reports',
    iconName: 'report-analytics',
    route: 'apps/reports',
    permission: 'reports',
    children: [
      {
        displayName: 'Overview',
        iconName: 'point',
        route: 'apps/reports',
        permission: 'reports',
      },
      {
        displayName: 'Station Payables',
        iconName: 'point',
        route: 'apps/reports/station-payables',
        permission: 'fuel_orders_payables',
      },
      {
        displayName: 'Station Credit Account',
        iconName: 'point',
        route: 'apps/reports/station-credit',
        permission: 'reports_station_credit',
      },
      {
        displayName: 'Station Orders',
        iconName: 'point',
        route: 'apps/reports/station-orders',
        permission: 'reports_station_orders',
      },
      {
        displayName: 'Station Fuel Ledger',
        iconName: 'point',
        route: 'apps/reports/station-fuel-account',
        permission: 'reports_station_fuel',
      },
      {
        displayName: 'Fuel Orders',
        iconName: 'point',
        route: 'apps/reports/fuel-orders',
        permission: 'reports_fuel_orders',
      },
      {
        displayName: 'Expenses',
        iconName: 'point',
        route: 'apps/reports/expenses',
        permission: 'reports_expenses',
      },
      {
        displayName: 'Vehicle Expenses',
        iconName: 'point',
        route: 'apps/reports/vehicle-expenses',
        permission: 'reports_vehicle_expenses',
      },
      {
        displayName: 'Petty Cash',
        iconName: 'point',
        route: 'apps/reports/petty-cash',
        permission: 'reports_petty_cash',
      },
      {
        displayName: 'Workshop Stock',
        iconName: 'point',
        route: 'apps/reports/workshop-stock',
        permission: 'reports_inventory',
      },
      {
        displayName: 'Tyres',
        iconName: 'point',
        route: 'apps/reports/tyres',
        permission: 'reports_tyres',
      },
    ],
  },

  {
    navCap: 'Settings',
  },

  {
    displayName: 'Users',
    iconName: 'users',
    route: 'apps/users',
    permission: 'users',
    children: [
      {
        displayName: 'Add',
        iconName: 'point',
        route: 'apps/users/add',
        permission: 'users',
        action: 'create',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/users/list',
        permission: 'users',
      },
    ],
  },

  {
    displayName: 'Roles',
    iconName: 'lock-access',
    route: 'apps/roles',
    permission: 'roles',
    children: [
      {
        displayName: 'Add',
        iconName: 'point',
        route: 'apps/roles/add',
        permission: 'roles',
        action: 'create',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/roles/list',
        permission: 'roles',
      }
    ],
  },

  {
    displayName: 'Branches',
    iconName: 'building-store',
    route: 'apps/branches',
    permission: 'branches',
    children: [
      {
        displayName: 'Add',
        iconName: 'point',
        route: 'apps/branches/add',
        permission: 'branches',
        action: 'create',
      },
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/branches/list',
        permission: 'branches',
      }
    ],
  },

  {
    displayName: 'Company Details',
    iconName: 'building',
    route: '/apps/companies/settings',
    permission: 'company',
  },

  {
    displayName: 'Account Setting',
    iconName: 'user-circle',
    route: '/apps/users/account',
  },
];
